new Swiper('.video-sliders', {
     navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
     },
     scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
     },
     breakpoints: {
        0: {
          slidesPerView: 2.5,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
     },
});


document.addEventListener('DOMContentLoaded', () => {
  const slides = document.querySelectorAll('.video-sliders .swiper-slide a[data-fancybox="gallery"]');

  slides.forEach(slide => {
    const video = slide.querySelector('video');
    if (video) {
      const source = video.querySelector('source');
      if (source && source.src) {
        slide.setAttribute('href', source.src); 
      }
    }
  });

  Fancybox.bind('[data-fancybox="gallery"]', {
    Toolbar: { display: ['close'] },
    Html: { video: { autoplay: true, controls: true } }
  });
});